/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsVideo = {
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsVideo = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors
    const $videoElement = $section.find('[data-video-element]');
    const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');
    const $imageElement = $section.find('[data-image-element]');

    // Load video if the media has been added
    if (this.iframe_video || this.html5_video) {
      this.loadVideo($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement);
    } else {
      $imageElement.show();
    }

  },
  loadVideo: function($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement) {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var isVimeo = this.video_type === 'vimeo';

    // Mobile Vimeo: skip Plyr entirely — player.play() breaks Safari's
    // user-gesture chain for cross-origin iframes.  Show the native Vimeo
    // embed (which has its own play button) when the user taps our overlay.
    if (isMobile && isVimeo) {
      // Hide video element initially; show poster image + text overlay
      $videoElement.hide();
      if (this.poster) {
        $imageElement.show();
        $videoTextContainer.show();
      } else {
        $imageElement.hide();
        $videoElement.show();
        $videoTextContainer.show();
      }

      var self = this;
      function showVimeoPlayer() {
        // Reveal the raw Vimeo iframe, hide our overlay
        $videoElement.show();
        $imageElement.hide();
        $videoTextContainer.hide();

        // Strip Plyr classes/wrappers if Plyr somehow initialised
        var plyrEl = $videoElement.find('.plyr');
        if (plyrEl.length) {
          plyrEl.find('.plyr__control--overlaid').hide();
          plyrEl.find('.plyr__poster').hide();
          plyrEl.find('.plyr__controls').hide();
          // Let taps pass through to the Vimeo iframe
          plyrEl.css('pointer-events', 'none');
          plyrEl.find('iframe').css('pointer-events', 'auto');
        }
      }

      $playButton.on('click', function(e) { e.preventDefault(); showVimeoPlayer(); });
      $videoTextContainer.on('click', showVimeoPlayer);
      $imageElement.on('click', showVimeoPlayer);
      return; // Skip Plyr initialisation entirely
    }

    // Non-mobile or non-Vimeo: initialize Plyr as normal
    const player = new Plyr(`.video-${this.id}`, {
      controls: videoControls,
      loop: {
        active: this.autoloop
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });

    player.muted = this.mute;
    player.ratio = this.aspect_ratio;

    // If autoplay enabled, hide image and text
    if (this.autoplay) {
      player.autoplay = true;
      $imageElement.hide();
      $videoTextContainer.hide();
      $videoElement.show();
    } else {
      // If autoplay disabled, check if poster image added
      if (this.poster) {
        $videoElement.hide();
        $imageElement.show();
        $videoTextContainer.show();
      } else {
        // If autoplay disabled and no poster image
        $imageElement.hide();
        $videoElement.show();
        $videoTextContainer.show();
      }
    }

    // If button exists, clicking button will play video
    if (this.button) {
      $playButton.on('click', () =>  {
        player.play();
      })
    }

    // Clicking anywhere on video should play the video
    if (!this.button) {
      $videoTextContainer.on('click', () => {
        player.play();
      })
    }

    // If on mobile and text is below image, clicking the image wrapper should play the video
    if (!isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
      $imageElement.on('click', () => {
        player.play();
      })
    }

    // On player ready, hide play icon if play button visible
    player.on('ready', function(index, player) {
      if ($playButton && !isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
        $playIcon.show();
      } else if ($playButton) {
        $playIcon.hide();
      } else {
        $playIcon.show();
      }
    })

    // On play, hide image/text and show video element
    player.on('play', function(index, player) {
      $videoElement.show();
      $imageElement.hide();
      $videoTextContainer.hide();
    })

    // On player pause, show play icon if play button hidden
    player.on('pause', function(index, player) {
      if (!$playButton) {
        $playIcon.show();
      }
    })

  },
  unload: function($section) {
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');

    $playButton.off();
    $videoTextContainer.off();
  }
}

/******/ })()
;